import { render, staticRenderFns } from "./app.settings.vue?vue&type=template&id=f1e2b752&lang=pug&"
import script from "./app.settings.vue?vue&type=script&lang=js&"
export * from "./app.settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports